import Vue from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueSimpleSuggest from 'vue-simple-suggest';

Vue.component('SimpleSuggest', VueSimpleSuggest);
